import React, {Component} from "react";
import {Field, formValueSelector, reduxForm} from "redux-form";
import {connect} from "react-redux";
import * as actions from "../../actions/index";
import {isChecked, priceList} from "../../util/broadcaster/profile_util";
import {renderField, renderTextAreaField,} from "../../util/account_management";
import {
    hideModal,
    isEmpty,
    navigate,
    openYotiIframe,
    removeWordFromList,
    required,
    showModal,
    vuepayAlert,
} from "../../util/utility";
import {getData, LOGIN} from "../../util/storage";
import {checkIfCreateBroadcast} from "../../util/broadcast";
import YotiConfirmModal from "../../components/modal/YotiModal";
//image
import loading_white from "../../assets/gif/loading_white.gif";
import {updateJWTToken} from "../../util/broadcast/create";
import information from "../../assets/images/information.svg";

// Tip goal size
const STEP = 1;
const MIN = 10;
const MAX = 10000;

class CreateBroadcast extends Component {
    constructor() {
        super();

        this.state = {
            count: 0,
            purpose_of_tip_count: 0,
            titleCount: 0,
            broadcast_type: "free",
            broadcast_session_type: "free",
            optionTemplate: priceList().map((v) => (
                <option key={v} value={v}>
                    {parseFloat(v / 100).toFixed(2)}
                </option>
            )),

            requireStream: true,
            yotiModalStatus: false,
            tip_goal_amount: 10,
        };

        //all the functions used in this component should be listed here for better documentation
        this.onSubmit = this.onSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleOneToOne = this.toggleOneToOne.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
        this.updateStatus = this.updateStatus.bind(this);
    }

    componentDidMount() {
        this.props.showLeftBar(); //hide the leftbar
        this.updateStatus();
        this.props.dispatch(this.props.change("broadcast_type", "free"));
        this.props.dispatch(this.props.change("broadcast_session_type", "free"));
        this.props.dispatch(this.props.change("age_group", "less_than_12"));
        this.props.dispatch(
            this.props.change("tip_goal_amount", this.state.tip_goal_amount)
        ); //tip goal amount

        //every time the create broadcast is loaded we check if the user api_token and token is available
        //it the api_token and token is available we do hit getUserDetails Webservice
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.getUserDetails(data.token, data.api_token);
            }
        });
    }

    isBroadcasterVerified = () => {
        return (
            this.props.account_management.userDetails !== null &&
            this.props.account_management.userDetails !== undefined &&
            this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].is_verified === 1
        );
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (checkIfCreateBroadcast(nextProps)) {
            //if the status_code received from the server is 200 means the user has successfully done the forgot password
            if (nextProps.broadcast.payload.status_code === 201) {
                nextProps.resetCreateBroadcast();

                updateJWTToken(nextProps.broadcast.payload, () => {
                    this.props.initializeTokBox(nextProps.broadcast.payload.data);
                    navigate(this.props, "broadcaster_start_broadcast_countdown");
                });

                vuepayAlert("success", nextProps.broadcast.payload.message);
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                nextProps.resetCreateBroadcast();
                vuepayAlert("error", nextProps.broadcast.payload.message);
            }
        }



        if (
            nextProps.account_management.yotiDetails !== null &&
            nextProps.account_management.userDetails.broadcaster[0].is_verified === 0
        ) {
            if (nextProps.account_management.yotiDetails.status_code === 422) {
                vuepayAlert("error", nextProps.account_management.yotiDetails.message);
                document.getElementsByClassName("modal-overlay")[0].style.display =
                    "none";
                const modal = document.getElementById("common-modal");
                hideModal(modal);

                //update the user details
                getData(LOGIN).then((data) => {
                    if (!isEmpty(data)) {
                        this.props.getUserDetails(data.token, data.api_token);
                    }
                });

                this.setState({
                    broadcast_type: "free",
                    yotiModalStatus: "false",
                });
                this.props.resetYotiDetail();
            } else {
                this.state.yotiModalStatus &&
                openYotiIframe(nextProps.account_management.yotiDetails.url);
                !this.state.yotiModalStatus &&
                this.props.broadcast_type === "paid" &&
                this.props.dispatch(this.props.change("broadcast_type", "free"));
                this.setState({
                    yotiModalStatus: false,
                    broadcast_type: "free",
                });
            }
        }
    }

    navCreateBroadcast = () => {
        this.setState({
            yotiModalStatus: false,
        });
        navigate(this.props, "broadcaster_create_broadcast");
    };

    onSubmit(values) {
        let formData = {
            session_title: values.session_title,
            session_description: values.session_description,
            age_group: values.age_group,
            broadcast_type: this.state.broadcast_type,
            one_to_one_session_allow: isChecked("one_to_one_session_allow"),
            one_to_one_session_price: parseInt(
                document.getElementsByName("one_to_one_session_price")[0].value
            ),
            group_session_price:
                this.state.broadcast_type === "free"
                    ? 0
                    : parseInt(
                    document.getElementsByName("group_session_price")[0].value
                    ),
            is_chat_allowed: true,
            is_hls: false,
            is_share_stream: values.is_share_stream,
            live_recording_to_library: values.live_recording_to_library,
            youtube_live_url: values.youtube_live_url,
            facebook_live_url: values.facebook_live_url,
            device: this.props.device,
        };

        if (values.is_tip_goal_allowed) {
            formData["is_tip_goal_allowed"] = values.is_tip_goal_allowed;
            formData["tip_goal_purpose"] = values.tip_goal_purpose;
            formData["tip_goal_amount"] = 100 * this.state.tip_goal_amount;
        }

        //dispatch an action to POST the channel picture/image to the Webservice
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.createBroadcast(data.token, data.api_token, formData);
            }
        });
    }

    updateStatus() {
        //dispatch an action to Update the broadcaster status to online
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.updateBroadcasterStatus(data.token, data.api_token, "1");
            }
        });
    }

    callYotiIntegration = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.yotiIntegration(data.token, data.api_token);
                this.setState({
                    yotiModalStatus: true,
                });
            }
        });
    };

    toggle(_type) {
        this.setState(
            {
                broadcast_type: _type,
            },
            () => {
                const index = _type === "free" ? 0 : 1,
                    target = document.getElementsByClassName("broadcast_type")[index],
                    oppositeIndex = _type === "free" ? 1 : 0,
                    oppositeTarget = document.getElementsByClassName("broadcast_type")[
                        oppositeIndex
                        ];

                if (target.classList.contains("active")) {
                    target.classList.remove("active");
                } else {
                    oppositeTarget.classList.remove("active");
                    target.classList.add("active");
                }
            }
        );
    }

    toggleOneToOne(_type) {
        this.setState({
            broadcast_type_onetoone: _type,
        });
    }

    handleOnTipBlur = (event, newValue, previousValue, name) => {

    }
    handleOnBlur = (event, newValue, previousValue, name) => {
        setTimeout(() => {
            const newData = removeWordFromList(
                this.props.account_management.userDetails.broadcaster[0].id,
                this.props.profanity,
                newValue,
                true,
                false
            );
            this.props.dispatch(this.props.change(name, newData));
        }, 0);
        name === "session_title" &&
        this.setState({
            titleCount: newValue.length,
        });
    };

    handleKeyPressTipGoalAmount = (e) => {
        this.setState({
            tip_goal_amount: e.target.value
        })
    }

    /**
     * @function listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(event, newValue, previousValue, name) {
        setTimeout(() => {
            const newData = removeWordFromList(
                this.props.account_management.userDetails.broadcaster[0].id,
                this.props.profanity,
                newValue,
                true,
                false
            );

            this.props.dispatch(this.props.change(name, newData));

            name != "tip_goal_purpose"
                ? this.setState({
                    count: newData.length,
                })
                : this.setState({
                    purpose_of_tip_count: newData.length,
                });
        }, 0);
    }



    handleChangeBroadcastType = (event, newValue, previousValue, name) => {
        if (!this.isBroadcasterVerified() && newValue === "paid") {
            const modal = document.getElementById("common-modal");
            showModal(modal);
        } else {
            this.props.dispatch(this.props.change("is_share_stream", false));
            this.props.dispatch(this.props.change("facebook_live_url", ""));
            this.props.dispatch(this.props.change("youtube_live_url", ""));
            this.setState({
                broadcast_type: newValue,
            });
        }
    };

    updateBroadcastType = () => {
        this.props.dispatch(this.props.change("broadcast_type", "free"));
        this.props.dispatch(this.props.change("broadcast_session_type", "free"));

        this.setState({
            broadcast_type: "free",
            broadcast_session_type: "free",
        });
    };

    handleChangeBroadcastSessionType = (event, newValue, previousValue, name) => {
        if (!this.isBroadcasterVerified() && newValue === "paid") {
            const modal = document.getElementById("common-modal");
            showModal(modal);
        } else {
            this.setState({
                broadcast_session_type: newValue,
            });
        }
    };

    handleChangeStrem = (event, newValue, previousValue, name) => {
        newValue
            ? this.setState({
                requireStream: false,
            })
            : this.setState({
                requireStream: true,
            });
    };

    render() {
        /**
         * TODO
         * update the Left bar to show broadcaster related menu
         */
        const {handleSubmit} = this.props;

        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="broadcast-container broadcast-type">
                            <div className="wrapper">
                                {
                                    <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        <dl className="row">
                                            <dt className="col-sm-3">Broadcast Type</dt>
                                            <dd className="col-sm-9">
                                                <div className="form-group">
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_type"
                                                            component="input"
                                                            type="radio"
                                                            value="free"
                                                            onChange={this.handleChangeBroadcastType}
                                                        />{" "}
                                                        Free
                                                    </label>
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_type"
                                                            component="input"
                                                            type="radio"
                                                            value="paid"
                                                            onChange={this.handleChangeBroadcastType}
                                                        />{" "}
                                                        Paid
                                                    </label>
                                                </div>
                                            </dd>
                                            <dt className="col-sm-3">Allow 1 on 1 sessions</dt>
                                            <dd className="col-sm-9">
                                                <label className="checkbox">
                                                    <Field
                                                        name="one_to_one_session_allow"
                                                        component="input"
                                                        type="checkbox"
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </dd>
                                            <dt
                                                className={
                                                    isChecked("one_to_one_session_allow")
                                                        ? "col-sm-3 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                1 on 1 session type
                                            </dt>
                                            <dd
                                                className={
                                                    isChecked("one_to_one_session_allow")
                                                        ? "col-sm-9 thing-enter"
                                                        : "col-sm-9 thing-leave"
                                                }
                                            >
                                                <div className="form-group">
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_session_type"
                                                            component="input"
                                                            type="radio"
                                                            value="free"
                                                            onChange={this.handleChangeBroadcastSessionType}
                                                        />{" "}
                                                        Free
                                                    </label>
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_session_type"
                                                            component="input"
                                                            type="radio"
                                                            value="paid"
                                                            onChange={this.handleChangeBroadcastSessionType}
                                                        />{" "}
                                                        Paid
                                                    </label>
                                                </div>
                                            </dd>
                                            <dt
                                                className={
                                                    isChecked("one_to_one_session_allow") &&
                                                    this.state.broadcast_session_type !== "free"
                                                        ? "col-sm-3 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                Set 1 on 1 price
                                            </dt>
                                            <dd
                                                className={
                                                    isChecked("one_to_one_session_allow") &&
                                                    this.state.broadcast_session_type !== "free"
                                                        ? "col-sm-9 thing-enter"
                                                        : "col-sm-9 thing-leave"
                                                }
                                            >
                                                <Field
                                                    className="custom-select"
                                                    name="one_to_one_session_price"
                                                    component="select"
                                                >
                                                    {this.state.broadcast_session_type === "free" ? (
                                                        <option key={0.0} value={0.0}>
                                                            0.00
                                                        </option>
                                                    ) : (
                                                        this.state.optionTemplate
                                                    )}
                                                </Field>
                                                <span>£/min</span>
                                            </dd>
                                            <dt
                                                className={
                                                    this.state.broadcast_type === "paid"
                                                        ? "col-sm-3 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                Set group price
                                            </dt>
                                            <dd
                                                className={
                                                    this.state.broadcast_type === "paid"
                                                        ? "col-sm-9 thing-enter"
                                                        : "col-sm-9 thing-leave"
                                                }
                                            >
                                                <Field
                                                    className="custom-select"
                                                    name="group_session_price"
                                                    component="select"
                                                >
                                                    {this.state.optionTemplate}
                                                </Field>
                                                <span>£/min</span>
                                            </dd>
                                            <dt className="col-sm-3">Enter session title</dt>
                                            <dd className="col-sm-9">
                                                <Field
                                                    label=""
                                                    name="session_title"
                                                    type="text"
                                                    count={this.state.titleCount}
                                                    onBlur={this.handleOnBlur}
                                                    onChange={this.handleOnBlur}
                                                    height={"32px"}
                                                    username={null}
                                                    maxLength={40}
                                                    validate={[required]}
                                                    component={renderField}
                                                />
                                            </dd>
                                            <dt className="col-sm-3">Enter session description</dt>
                                            <dd className="col-sm-9">
                                                <div className="form-group">
                                                    <Field
                                                        label=""
                                                        name="session_description"
                                                        maxLength="280"
                                                        minLength="1"
                                                        // onChange={this.handleOnBlur}
                                                        onBlur={this.textAreaChange}
                                                        height={"153px"}
                                                        count={this.state.count}
                                                        validate={[required]}
                                                        component={renderTextAreaField}
                                                        onChange={this.textAreaChange}
                                                    />
                                                </div>
                                            </dd>
                                            <br/>
                                            <dt className="col-sm-3">
                                                Age rating
                                                <a
                                                    href="https://www.bbfc.co.uk/about-classification/classification-guidelines"
                                                    target="_blank"
                                                >
                                                    <img
                                                        alt={"close-icon"}
                                                        width="18"
                                                        src={information}
                                                    />
                                                </a>
                                            </dt>
                                            <dd className="col-sm-9">
                                                <div className="form-group">
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="less_than_12"
                                                        />{" "}
                                                        Under 12
                                                    </label>
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="more_than_12"
                                                        />{" "}
                                                        12+
                                                    </label>
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="more_than_15"
                                                        />{" "}
                                                        15+
                                                    </label>
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="18"
                                                        />{" "}
                                                        18
                                                    </label>
                                                </div>
                                            </dd>

                                            {/*Tip Goal*/}
                                            <dt className="col-sm-3">Like Goal</dt>
                                            <dd className="col-sm-9">
                                                <label className="checkbox">
                                                    <Field
                                                        name="is_tip_goal_allowed"
                                                        component="input"
                                                        type="checkbox"
                                                        disabled={this.state.isTipGoalExist}
                                                    />
                                                    <span className="checkmark"/>
                                                </label>
                                            </dd>
                                            {/*Tip Goal*/}

                                            {/*Tip Goal Amount*/}
                                            <dt className={this.props.tip_goal ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Like Goal Amount
                                            </dt>
                                            <dd className={this.props.tip_goal ? "col-sm-9 thing-enter" : "col-sm-9 thing-leave"}>
                                                <Field
                                                    label="Please enter a value between £10 and £10k"
                                                    name="tip_goal_amount"
                                                    type="number"
                                                    onChange={this.handleKeyPressTipGoalAmount}
                                                    height={"32px"}
                                                    username={null}
                                                    component={renderField}
                                                    hideMaxLength
                                                    min={1}
                                                    max={10000}
                                                    validate={this.props.tip_goal && [required]}
                                                />
                                            </dd>
                                            {/*Tip Goal Amount*/}

                                            {/*Purpose of Like*/}
                                            <dt className={this.props.tip_goal ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Purpose of Like
                                            </dt>
                                            <dd className={this.props.tip_goal ? "col-sm-9 thing-enter" : "col-sm-9 thing-leave"}>
                                                <div className="form-group">
                                                    <Field
                                                        label=""
                                                        name="tip_goal_purpose"
                                                        maxLength="500"
                                                        minLength="1"
                                                        onBlur={this.textAreaChange}
                                                        height={"124px"}
                                                        count={this.state.purpose_of_tip_count}
                                                        validate={this.props.tip_goal && [required]}
                                                        component={renderTextAreaField}
                                                        onChange={this.textAreaChange}
                                                        disabled={this.state.isTipGoalExist}
                                                    />
                                                </div>
                                            </dd>
                                            {/*Purpose of Like*/}

                                            <dt
                                                className={
                                                    this.state.broadcast_type === "free"
                                                        ? "col-sm-3 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                Share stream
                                            </dt>
                                            <dd
                                                className={
                                                    this.state.broadcast_type === "free"
                                                        ? "col-sm-9 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                <label className="checkbox">
                                                    <Field
                                                        name="is_share_stream"
                                                        component="input"
                                                        type="checkbox"
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </dd>
                                            <dt
                                                className={
                                                    this.state.broadcast_type === "free" &&
                                                    this.props.share_stream
                                                        ? "col-sm-3 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                YouTube Live url
                                            </dt>
                                            <dd
                                                className={
                                                    this.state.broadcast_type === "free" &&
                                                    this.props.share_stream
                                                        ? "col-sm-9 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                <div className="form-group">
                                                    <Field
                                                        label=""
                                                        name="youtube_live_url"
                                                        type="text"
                                                        onChange={this.handleChangeStrem}
                                                        height={"32px"}
                                                        username={null}
                                                        validate={
                                                            this.props.share_stream &&
                                                            this.state.requireStream && [required]
                                                        }
                                                        maxLength={200}
                                                        component={renderField}
                                                    />
                                                </div>
                                            </dd>
                                            <dt
                                                className={
                                                    this.state.broadcast_type === "free" &&
                                                    this.props.share_stream
                                                        ? "col-sm-3 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                Facebook Live url
                                            </dt>
                                            <dd
                                                className={
                                                    this.state.broadcast_type === "free" &&
                                                    this.props.share_stream
                                                        ? "col-sm-9 thing-enter"
                                                        : "col-sm-3 thing-leave"
                                                }
                                            >
                                                <div className="form-group">
                                                    <Field
                                                        label=""
                                                        name="facebook_live_url"
                                                        type="text"
                                                        onChange={this.handleChangeStrem}
                                                        height={"32px"}
                                                        username={null}
                                                        validate={
                                                            this.props.share_stream &&
                                                            this.state.requireStream && [required]
                                                        }
                                                        maxLength={200}
                                                        component={renderField}
                                                    />
                                                </div>
                                            </dd>

                                            {/*Add recording to library*/}
                                            <dt className="col-sm-3">Add recording to library</dt>
                                            <dd className="col-sm-9">
                                                <label className="checkbox">
                                                    <Field
                                                        name="live_recording_to_library"
                                                        component="input"
                                                        type="checkbox"
                                                    />
                                                    <span className="checkmark"/>
                                                </label>
                                            </dd>
                                            {/*Add recording to library*/}
                                        </dl>

                                        <div className="mt-4 text-right">
                                            {this.props.broadcast.isFetching ? (
                                                <button
                                                    className="btn btn-outline-primary w-100"
                                                    type="button"
                                                >
                                                    <img
                                                        src={loading_white}
                                                        alt={"Loading"}
                                                        width={26}
                                                        height={26}
                                                    />
                                                </button>
                                            ) : (
                                                <button className="btn btn-outline-primary w-100">
                                                    Go Live
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>


                        <YotiConfirmModal
                            isCreateProfile={false}
                            yotiModalStatus={this.state.yotiModalStatus}
                            callYotiIntegration={this.callYotiIntegration}
                            updateBroadcastType={this.updateBroadcastType}
                            updateType={true}
                            navCreateBroadcast={this.navCreateBroadcast}
                        />
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector("CreateBroadcastForm");
    return {
        broadcast_type: selector(state, "broadcast_type"),
        share_stream: selector(state, "is_share_stream"),
        tip_goal: selector(state, "is_tip_goal_allowed"),
        account_management: state.account_management,
        broadcast: state.broadcast,
        device: state.device.payload,
        profanity: state.profanity.words,
    };
}

export default reduxForm({
    form: "CreateBroadcastForm",
})(connect(mapStateToProps, actions)(CreateBroadcast));
